import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { IAppState } from "../../app/appTypes"
import { store } from "../../app/state/store"

type AppDispatch = typeof store.dispatch
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<IAppState> = useSelector
